import Image from 'next/image';
import { FC } from 'react';
import { StyledBGImage } from './BGImage.styles';
import { IBGImage } from './BGImage.type';

const BGImage: FC<IBGImage> = ({ src, ...otherProps }) => {
	return (
		<StyledBGImage {...otherProps}>
			<Image quality={100} src={src} alt='' layout='fill' objectFit='cover' draggable={false} />
		</StyledBGImage>
	);
};

export { BGImage };
